import {
  DEFAULT_DATA_CREDITS_VALUE_MAP,
  DEFAULT_DATA_SPEED_DOWN_VALUE_MAP,
  DEFAULT_MONTHLY_FEE_VALUE_MAP,
  DEFAULT_PRICE_VALUE_MAP
} from "../../filters";
import { UNLIMITED } from "../../unlimited";

export const DATA_CREDITS_VALUE_MAP = DEFAULT_DATA_CREDITS_VALUE_MAP;
export const DATA_SPEED_DOWN_VALUE_MAP = DEFAULT_DATA_SPEED_DOWN_VALUE_MAP;
export const MONTHLY_FEE_VALUE_MAP = DEFAULT_MONTHLY_FEE_VALUE_MAP;
export const PRICE_VALUE_MAP = DEFAULT_PRICE_VALUE_MAP;
export const VOICE_CREDITS_VALUE_MAP = {
  0: 0,
  1: 60,
  2: 120,
  3: 180,
  4: 240,
  5: 300,
  6: 360,
  7: 420,
  8: 480,
  9: 540,
  10: 600,
  11: 660,
  12: 720,
  13: 780,
  14: 840,
  15: 900,
  16: 960,
  17: 1020,
  18: 1080,
  19: 1140,
  20: 1200,
  21: 1260,
  22: 1320,
  23: 1380,
  24: 1440,
  25: 1500,
  26: 1560,
  27: 1620,
  28: 1680,
  29: 1740,
  30: UNLIMITED
};
